import { render } from "./BuildInformation.vue?vue&type=template&id=317dff70&scoped=true"
import script from "./BuildInformation.vue?vue&type=script&lang=js"
export * from "./BuildInformation.vue?vue&type=script&lang=js"

import "./BuildInformation.vue?vue&type=style&index=0&id=317dff70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317dff70"]])

export default __exports__